import React, { useState, useEffect, useMemo } from "react";
import Cookies from "js-cookie";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import Link from "@mui/material/Link";
import logo from "../../assets/images/logo.png";
import eng1 from "../../assets/images/eng.png";
import arb1 from "../../assets/images/arb.png";
import "./Header.css";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link as RouterLink } from "react-router-dom";

import useTranslations from "../../custom-hooks/useTranslations";
import { getHelperData } from "../../actions/getHelperData";
import { getExamBoards } from "../../actions/getExamBoardsAction";
import { getTranslations } from "../../actions/getTranslationAction";
import { updateStudentProfile } from "../../actions/updateStudentProfileAction";
import { getTopics } from "../../actions/quickCallsAction";
import useSocket from "../../custom-hooks/useSocket";

import { signOut } from "firebase/auth";
import { auth } from "../../firebase";
import i18n from "../../i18n";
import useStudyMaterial from "../../custom-hooks/useStudyMaterial";

const pages = [
  { name: "QuickCallBtn", route: "/quick-call" },
  { name: "FindTutor", route: "/hire-tutor" },
  { name: "PrivateClass", route: "/private-class" },
  { name: "QuickCourses", route: "/courses" },
  { name: "PracticeEvaluate", route: "/test" },
  { name: "Wallet", route: "/wallet" },
];

const Header = React.memo(() => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { socket, isConnected } = useSocket();
  const { studyMaterial } = useStudyMaterial();

  const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [selectedFlag, setSelectedFlag] = useState(
    localStorage.getItem("I18N_LANGUAGE")
  );

  const translations = useTranslations();
  const courses = useSelector(({ coursesReducer }) => coursesReducer.courses || []);
  const gettranslations = useSelector(({ getTranslationsReducer }) => getTranslationsReducer.translations || []);
  const classes = useSelector(({ classReducer }) => classReducer.classes);


  const localizations ={
    ...gettranslations[33]?.ApplicationConfiguration
  }

  console.log("updatedPages",localizations?.PrivateClassEnable === "true" && classes?.length > 0);
  
    
  const updatedPages = useMemo(() => {
    return pages.filter(({ name }) => {
      if (name === "QuickCourses") {
        return localizations?.GroupCourseEnableForWeb === "true" && (courses?.AllCourses?.length ?? 0) > 0;
      }
  
      if (name === "PrivateClass") {
        return localizations?.PrivateClassEnable === "true" && (classes?.length ?? 0) > 0;
      }
  
      if (name === "PracticeEvaluate") {
        return (studyMaterial?.length ?? 0) > 0;
      }
  
      return true;
    });
  }, [courses, localizations, classes, studyMaterial]);
  
  
    
  

  const translation = useMemo(
    () => ({
      ...translations[3]?.MenuScreen, 
      ...translations[8]?.PrivateClassDashboard,
      ...translations[21]?.CommonFrontend,
      ...translations[26]?.QuickCall,
    }),
    [translations]
  );

  const profileInfo = Cookies.get("ProfileInfo")
    ? JSON.parse(Cookies.get("ProfileInfo"))
    : null;

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleNavigate = (route) => {
    navigate(route);
  };

  const handleContactUs = () => {
    window.open("https://getyasa.com/", "_blank");
  };

  const handleLogout = () => {
    
    dispatch({ type: 'LOGOUT' });
    // socket?.disconnect();
    dispatch(getTranslations());
    
    sessionStorage.clear();
    // Clear all cookies
    Object.keys(Cookies.get()).forEach((cookieName) => {
      Cookies.remove(cookieName);
    });
    signOut(auth);
    navigate("/login");
  };

  const changeLanguage = (lang) => {
    if (selectedFlag !== lang) {
      setSelectedFlag(lang);
      localStorage.setItem("I18N_LANGUAGE", lang);
      localStorage.setItem("langId", lang === "en" ? 1 : 2);
      if (profileInfo) {
        const obj = {
          UserName: profileInfo.UserName,
          email: profileInfo?.Email,
          StudentGenderID: profileInfo?.GenderID,
          StudentGradeID: profileInfo?.StudentGradeID,
          StudentExaminationID: profileInfo?.StudentExaminationID,
          StudentTargetExamID: profileInfo?.StudentTargetExamID,
          StudentSubExaminationID: profileInfo?.StudentSubExaminationID,
          TeachingLanguage: profileInfo?.AppLanguageID,
          AppLanguage: lang === "en" ? 1 : 2,
        };
        dispatch(updateStudentProfile(obj));
        dispatch(
          getTopics({
            GradeID: profileInfo?.StudentGradeID,
            ExamID: profileInfo?.StudentExaminationID,
          })
        );
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    }
    // setSelectedFlag(lang);
    // localStorage.setItem("I18N_LANGUAGE", lang);
    // localStorage.setItem("langId", lang === "en" ? 1 : 2);
    // i18n.changeLanguage(lang);
    // document.body.dir = i18n.dir();
    // if (selectedFlag !== lang) {
    //   dispatch(getTranslations());
    //   dispatch(getHelperData());
    //   dispatch(getExamBoards());
    // }
    // if (profileInfo) {
    //   const obj = {
    //     "UserName": profileInfo.UserName,
    //     "email": profileInfo?.Email,
    //     "StudentGenderID": profileInfo?.GenderID,
    //     "StudentGradeID": profileInfo?.StudentGradeID,
    //     "StudentExaminationID": profileInfo?.StudentExaminationID,
    //     "StudentTargetExamID": profileInfo?.StudentTargetExamID,
    //     "StudentSubExaminationID": profileInfo?.StudentSubExaminationID,
    //     "TeachingLanguage": profileInfo?.AppLanguageID,
    //     "AppLanguage": lang === "en" ? 1 : 2
    //   }
    //   dispatch(updateStudentProfile(obj));
    //   dispatch(getTopics({ GradeID: profileInfo?.StudentGradeID, ExamID: profileInfo?.StudentExaminationID }));
    // }
    // setAnchorElUser(null);
  };

  return (
    <AppBar className="headerMain" position="static">
      <Container maxWidth="false">
        <Toolbar disableGutters className="logoLeft">
          <Typography
            variant="h6"
            noWrap
            component="a"
            href="#app-bar-with-responsive-menu"
            sx={{
              mr: 2,
              display: { xs: "none", md: "none" },
            }}
          ></Typography>

          <Box
            className="menuBar"
            sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}
          >
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              className="mobMenu"
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "block", md: "none" },
              }}
            >
              {/* //mobile */}
              {updatedPages?.map((page) => (
                <MenuItem onClick={handleCloseNavMenu} key={page.name}>
                  {page.name == "Wallet" ? (
                    <>
                      <svg
                        width="18"
                        height="16"
                        viewBox="0 0 22 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M8.944 0.25H12.056C13.894 0.25 15.35 0.25 16.489 0.403C17.661 0.561 18.61 0.893 19.359 1.641C20.283 2.566 20.578 3.804 20.685 5.411C21.262 5.664 21.698 6.201 21.745 6.881C21.75 6.942 21.75 7.007 21.75 7.067V10.933C21.75 10.993 21.75 11.058 21.746 11.118C21.698 11.798 21.262 12.336 20.685 12.59C20.578 14.196 20.283 15.434 19.359 16.359C18.61 17.107 17.661 17.439 16.489 17.597C15.349 17.75 13.894 17.75 12.056 17.75H8.944C7.106 17.75 5.65 17.75 4.511 17.597C3.339 17.439 2.39 17.107 1.641 16.359C0.893 15.61 0.561 14.661 0.403 13.489C0.25 12.349 0.25 10.894 0.25 9.056V8.944C0.25 7.106 0.25 5.65 0.403 4.511C0.561 3.339 0.893 2.39 1.641 1.641C2.39 0.893 3.339 0.561 4.511 0.403C5.651 0.25 7.106 0.25 8.944 0.25ZM19.168 12.75H17.23C15.085 12.75 13.249 11.122 13.249 9C13.249 6.878 15.085 5.25 17.229 5.25H19.167C19.053 3.909 18.796 3.2 18.297 2.702C17.874 2.279 17.294 2.025 16.288 1.89C15.261 1.752 13.906 1.75 11.999 1.75H8.999C7.092 1.75 5.738 1.752 4.709 1.89C3.704 2.025 3.124 2.279 2.701 2.702C2.278 3.125 2.024 3.705 1.889 4.711C1.751 5.739 1.749 7.093 1.749 9C1.749 10.907 1.751 12.262 1.889 13.29C2.024 14.295 2.278 14.875 2.701 15.298C3.124 15.721 3.704 15.975 4.71 16.11C5.738 16.248 7.092 16.25 8.999 16.25H11.999C13.906 16.25 15.261 16.248 16.289 16.11C17.294 15.975 17.874 15.721 18.297 15.298C18.796 14.8 19.054 14.092 19.168 12.75ZM4.25 5C4.25 4.80109 4.32902 4.61032 4.46967 4.46967C4.61032 4.32902 4.80109 4.25 5 4.25H9C9.19891 4.25 9.38968 4.32902 9.53033 4.46967C9.67098 4.61032 9.75 4.80109 9.75 5C9.75 5.19891 9.67098 5.38968 9.53033 5.53033C9.38968 5.67098 9.19891 5.75 9 5.75H5C4.80109 5.75 4.61032 5.67098 4.46967 5.53033C4.32902 5.38968 4.25 5.19891 4.25 5ZM19.924 6.75H17.23C15.806 6.75 14.749 7.809 14.749 9C14.749 10.191 15.806 11.25 17.229 11.25H19.947C20.153 11.237 20.242 11.098 20.249 11.014V6.986C20.242 6.902 20.153 6.763 19.947 6.751L19.924 6.75Z"
                          fill={
                            window.location.pathname === page.route
                              ? "#EA4435"
                              : "#555555"
                          }
                        />
                      </svg>
                      <Typography
                        textAlign="center"
                        className={
                          window.location.pathname === page.route
                            ? "activeMobMenu"
                            : ""
                        }
                      >
                        {translation[page.name]}
                      </Typography>
                    </>
                  ) : (
                    <Typography
                      textAlign="center"
                      className={
                        window.location.pathname === page.route
                          ? "activeMobMenu"
                          : ""
                      }
                      onClick={() => handleNavigate(page.route)}
                    >
                      {translation[page.name]}
                    </Typography>
                  )}
                </MenuItem>
              ))}
            </Menu>
          </Box>

          <RouterLink className="web-logo" to="/">
            <img src={logo} alt="logo"></img>
          </RouterLink>

          <Box
            className="headerManu"
            sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}
          >
            {updatedPages.map((page) => (
              <React.Fragment key={page.name}>
                {page.name == "Wallet" ? (
                  <Button
                    onClick={() => handleNavigate(page.route)}
                    sx={{ my: 2, color: "white", display: "block" }}
                    className={
                      window.location.pathname === page.route
                        ? "activeMenu"
                        : ""
                    }
                  >
                    <a>
                      <svg
                        width="18"
                        height="16"
                        viewBox="0 0 22 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M8.944 0.25H12.056C13.894 0.25 15.35 0.25 16.489 0.403C17.661 0.561 18.61 0.893 19.359 1.641C20.283 2.566 20.578 3.804 20.685 5.411C21.262 5.664 21.698 6.201 21.745 6.881C21.75 6.942 21.75 7.007 21.75 7.067V10.933C21.75 10.993 21.75 11.058 21.746 11.118C21.698 11.798 21.262 12.336 20.685 12.59C20.578 14.196 20.283 15.434 19.359 16.359C18.61 17.107 17.661 17.439 16.489 17.597C15.349 17.75 13.894 17.75 12.056 17.75H8.944C7.106 17.75 5.65 17.75 4.511 17.597C3.339 17.439 2.39 17.107 1.641 16.359C0.893 15.61 0.561 14.661 0.403 13.489C0.25 12.349 0.25 10.894 0.25 9.056V8.944C0.25 7.106 0.25 5.65 0.403 4.511C0.561 3.339 0.893 2.39 1.641 1.641C2.39 0.893 3.339 0.561 4.511 0.403C5.651 0.25 7.106 0.25 8.944 0.25ZM19.168 12.75H17.23C15.085 12.75 13.249 11.122 13.249 9C13.249 6.878 15.085 5.25 17.229 5.25H19.167C19.053 3.909 18.796 3.2 18.297 2.702C17.874 2.279 17.294 2.025 16.288 1.89C15.261 1.752 13.906 1.75 11.999 1.75H8.999C7.092 1.75 5.738 1.752 4.709 1.89C3.704 2.025 3.124 2.279 2.701 2.702C2.278 3.125 2.024 3.705 1.889 4.711C1.751 5.739 1.749 7.093 1.749 9C1.749 10.907 1.751 12.262 1.889 13.29C2.024 14.295 2.278 14.875 2.701 15.298C3.124 15.721 3.704 15.975 4.71 16.11C5.738 16.248 7.092 16.25 8.999 16.25H11.999C13.906 16.25 15.261 16.248 16.289 16.11C17.294 15.975 17.874 15.721 18.297 15.298C18.796 14.8 19.054 14.092 19.168 12.75ZM4.25 5C4.25 4.80109 4.32902 4.61032 4.46967 4.46967C4.61032 4.32902 4.80109 4.25 5 4.25H9C9.19891 4.25 9.38968 4.32902 9.53033 4.46967C9.67098 4.61032 9.75 4.80109 9.75 5C9.75 5.19891 9.67098 5.38968 9.53033 5.53033C9.38968 5.67098 9.19891 5.75 9 5.75H5C4.80109 5.75 4.61032 5.67098 4.46967 5.53033C4.32902 5.38968 4.25 5.19891 4.25 5ZM19.924 6.75H17.23C15.806 6.75 14.749 7.809 14.749 9C14.749 10.191 15.806 11.25 17.229 11.25H19.947C20.153 11.237 20.242 11.098 20.249 11.014V6.986C20.242 6.902 20.153 6.763 19.947 6.751L19.924 6.75Z"
                          fill="white"
                        />
                      </svg>
                    </a>
                    {translation[page.name]}
                  </Button>
                ) : (
                  <Button
                    onClick={() => handleNavigate(page.route)}
                    sx={{ my: 2, color: "white", display: "block" }}
                    className={
                      window.location.pathname === page.route
                        ? "activeMenu"
                        : ""
                    }
                  >
                    {translation[page.name]}
                  </Button>
                )}
              </React.Fragment>
            ))}
          </Box>

          <Box className="userProfile" sx={{ flexGrow: 0 }}>
            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
              <Avatar
                alt={profileInfo?.UserName}
                src="/static/images/avatar/2.jpg"
              />
              <a>
                <svg
                  width="10"
                  height="6"
                  viewBox="0 0 10 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.9996 5.50009C4.90106 5.50055 4.80342 5.48133 4.71241 5.44355C4.6214 5.40577 4.53885 5.3502 4.4696 5.28009L0.999603 1.78009C0.908212 1.63913 0.866791 1.47157 0.881978 1.30427C0.897166 1.13696 0.968083 0.979602 1.08336 0.857406C1.19864 0.73521 1.35161 0.655255 1.51774 0.630355C1.68388 0.605456 1.85357 0.637055 1.9996 0.720087L4.9996 3.72009L7.9996 0.720087C8.14564 0.637055 8.31533 0.605456 8.48146 0.630355C8.6476 0.655255 8.80056 0.73521 8.91584 0.857406C9.03112 0.979602 9.10204 1.13696 9.11723 1.30427C9.13241 1.47157 9.09099 1.63913 8.9996 1.78009L5.4996 5.28009C5.36709 5.4145 5.18823 5.4932 4.9996 5.50009Z"
                    fill="white"
                  />
                </svg>
              </a>
            </IconButton>

            <Menu
              className="profileDropDown"
              sx={{ mt: "45px" }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              <MenuItem>
                <Link
                  variant="a"
                  textAlign="center"
                  onClick={() => handleNavigate("/user-profile")}
                >
                  <span className="iconCircle">
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 9.5913 6.63214 11.1174 7.75736 12.2426C8.88258 13.3679 10.4087 14 12 14C13.5913 14 15.1174 13.3679 16.2426 12.2426C17.3679 11.1174 18 9.5913 18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2ZM12 12C10.9391 12 9.92172 11.5786 9.17157 10.8284C8.42143 10.0783 8 9.06087 8 8C8 6.93913 8.42143 5.92172 9.17157 5.17157C9.92172 4.42143 10.9391 4 12 4C13.0609 4 14.0783 4.42143 14.8284 5.17157C15.5786 5.92172 16 6.93913 16 8C16 9.06087 15.5786 10.0783 14.8284 10.8284C14.0783 11.5786 13.0609 12 12 12ZM12 16C9.87827 16 7.84344 16.8429 6.34315 18.3431C4.84285 19.8434 4 21.8783 4 24H6C6 22.4087 6.63214 20.8826 7.75736 19.7574C8.88258 18.6321 10.4087 18 12 18C13.5913 18 15.1174 18.6321 16.2426 19.7574C17.3679 20.8826 18 22.4087 18 24H20C20 21.8783 19.1571 19.8434 17.6569 18.3431C16.1566 16.8429 14.1217 16 12 16Z"
                        fill="white"
                      />
                    </svg>
                    {/* <svg
                      width="9"
                      height="13"
                      viewBox="0 0 9 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.46 0.14H8.36C8.53333 0.14 8.62 0.226666 8.62 0.399999V10.04C8.62 10.9733 8.35333 11.7 7.82 12.22C7.3 12.74 6.58667 13 5.68 13H3.68C2.76 13 2.03333 12.74 1.5 12.22C0.98 11.6867 0.72 10.96 0.72 10.04V8.32C0.72 8.13333 0.813333 8.04 1 8.04H1.9C2.08667 8.04 2.18 8.13333 2.18 8.32V9.98C2.18 11.14 2.74 11.72 3.86 11.72H5.5C6.62 11.72 7.18 11.14 7.18 9.98V0.42C7.18 0.233333 7.27333 0.14 7.46 0.14Z"
                        fill="#fff"
                      />
                    </svg> */}
                  </span>{" "}
                  {translation?.Profile}
                </Link>
                <Link
                  variant="a"
                  textAlign="center"
                  onClick={() => handleNavigate("/session-list")}
                >
                  <span className="iconCircle">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 9.5913 6.63214 11.1174 7.75736 12.2426C8.88258 13.3679 10.4087 14 12 14C13.5913 14 15.1174 13.3679 16.2426 12.2426C17.3679 11.1174 18 9.5913 18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2ZM12 12C10.9391 12 9.92172 11.5786 9.17157 10.8284C8.42143 10.0783 8 9.06087 8 8C8 6.93913 8.42143 5.92172 9.17157 5.17157C9.92172 4.42143 10.9391 4 12 4C13.0609 4 14.0783 4.42143 14.8284 5.17157C15.5786 5.92172 16 6.93913 16 8C16 9.06087 15.5786 10.0783 14.8284 10.8284C14.0783 11.5786 13.0609 12 12 12ZM12 16.99C11.67 16.99 11.35 17.07 11.06 17.24L6.35 20C6.27 20.04 6.19 20.08 6.11 20.1C6.04 20.12 5.97 20.14 5.9 20.15V9.27C6.25 9.1 7.07 8.78 8 8.78C8.93 8.78 9.75 9.1 10.1 9.27L12 10.28L13.9 9.27C14.25 9.1 15.07 8.78 16 8.78C16.93 8.78 17.75 9.1 18.1 9.27V20.15C18.03 20.14 17.96 20.12 17.89 20.1C17.81 20.08 17.73 20.04 17.65 20L12.94 17.24C12.65 17.07 12.33 16.99 12 16.99Z"
                        fill="white"
                      />
                    </svg>
                  </span>{" "}
                  {translation?.MySession}
                </Link>
                {/* <Link
                  variant="a"
                  textAlign="center"
                  onClick={() => handleNavigate("/refer-earn")}
                >
                  <span className="iconCircle">
                    <svg
                      width="12"
                      height="13"
                      viewBox="0 0 12 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1.3074 12.0344H1.03215e-05V5.49905C-0.00118849 5.05261 0.102057 4.61207 0.301497 4.21265C0.57228 3.6151 1.00938 3.10814 1.56057 2.75236C2.11175 2.39658 2.75372 2.20701 3.40976 2.20631H6.83348V0H7.89554L12 4.10449L7.88097 8.22352H6.83348V6.01721H4.60681C4.14105 6.01834 3.68837 6.17132 3.31739 6.45294C2.94642 6.73456 2.67739 7.12946 2.55111 7.57777L1.3074 12.0344ZM3.40976 3.0086C2.9069 3.00914 2.41488 3.15477 1.99274 3.42802C1.5706 3.70127 1.23627 4.09053 1.02988 4.54908L1.02256 4.56448C0.876809 4.8544 0.801356 5.17456 0.802305 5.49905V10.8596L1.77835 7.36213C1.95209 6.74528 2.32224 6.20192 2.83267 5.81443C3.3431 5.42694 3.96596 5.21646 4.60681 5.21491H7.63577V7.3341L10.8654 4.10449L7.63577 0.874852V3.0086H3.40976Z"
                        fill="white"
                      />
                    </svg>
                  </span>{" "}
                  {translation?.ReferEarn}
                </Link> */}
                <Link variant="a" textAlign="center" onClick={handleContactUs}>
                  <span className="iconCircle">
                    <svg
                      width="13"
                      height="13"
                      viewBox="0 0 13 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.8494 9.01927L8.89688 7.69615C8.76311 7.63883 8.61715 7.61578 8.47222 7.6291C8.32729 7.64241 8.18797 7.69167 8.06688 7.7724C8.05462 7.78032 8.04292 7.78909 8.03188 7.79865L6.48876 9.11115C6.47275 9.11988 6.45492 9.12476 6.4367 9.12541C6.41848 9.12606 6.40035 9.12246 6.38376 9.1149C5.39188 8.63615 4.36438 7.6149 3.88376 6.63677C3.87575 6.62043 3.87159 6.60247 3.87159 6.58427C3.87159 6.56608 3.87575 6.54812 3.88376 6.53177L5.20063 4.96927C5.2101 4.95772 5.21886 4.94562 5.22688 4.93302C5.3065 4.81146 5.35459 4.67199 5.36681 4.52719C5.37903 4.38239 5.355 4.23683 5.29688 4.10365L3.98313 1.15615C3.90853 0.982155 3.7795 0.837051 3.61542 0.742615C3.45134 0.648179 3.26106 0.609506 3.07313 0.632399C2.2564 0.739772 1.5067 1.14086 0.964146 1.76071C0.421589 2.38056 0.123295 3.17676 0.125007 4.00052C0.125007 8.89427 4.10626 12.8755 9.00001 12.8755C9.82373 12.8771 10.6199 12.5788 11.2397 12.0362C11.8595 11.4937 12.2606 10.7441 12.3681 9.9274C12.391 9.74035 12.3528 9.55093 12.2594 9.3873C12.1659 9.22368 12.0221 9.0946 11.8494 9.01927ZM9.00001 12.1255C4.52001 12.1255 0.875007 8.48052 0.875007 4.00052C0.872918 3.35923 1.10438 2.73911 1.52616 2.25603C1.94794 1.77295 2.53117 1.45995 3.16688 1.37552H3.18126C3.20644 1.37599 3.2309 1.38406 3.25142 1.39867C3.27194 1.41328 3.28757 1.43375 3.29626 1.4574L4.61501 4.40177C4.62253 4.41814 4.62642 4.43595 4.62642 4.45396C4.62642 4.47198 4.62253 4.48978 4.61501 4.50615L3.29563 6.0724C3.28584 6.08362 3.27686 6.09552 3.26876 6.10802C3.1862 6.23406 3.13758 6.37928 3.12762 6.52962C3.11765 6.67996 3.14668 6.83032 3.21188 6.96615C3.76626 8.10115 4.91001 9.23615 6.05751 9.79052C6.19413 9.85537 6.34523 9.88369 6.49606 9.87274C6.64689 9.86179 6.79231 9.81193 6.91813 9.72802C6.93001 9.7199 6.94188 9.71115 6.95313 9.70177L8.49563 8.38927C8.51087 8.38109 8.52769 8.37629 8.54495 8.37521C8.56221 8.37413 8.5795 8.3768 8.59563 8.38302L11.5488 9.70615C11.5729 9.71642 11.5932 9.73402 11.6067 9.75645C11.6203 9.77888 11.6265 9.80501 11.6244 9.83115C11.5404 10.4672 11.2277 11.0508 10.7447 11.4731C10.2617 11.8953 9.64153 12.1272 9.00001 12.1255Z"
                        fill="white"
                      />
                    </svg>
                  </span>{" "}
                  {translation?.ContactUs}
                </Link>
                <Link variant="a" textAlign="center" onClick={handleLogout}>
                  <span className="iconCircle">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.99984 2.16699C8.13245 2.16699 8.25962 2.21967 8.35339 2.31344C8.44716 2.40721 8.49984 2.53438 8.49984 2.66699C8.49984 2.7996 8.44716 2.92678 8.35339 3.02055C8.25962 3.11431 8.13245 3.16699 7.99984 3.16699C6.71796 3.16699 5.48858 3.67622 4.58215 4.58264C3.67573 5.48907 3.1665 6.71845 3.1665 8.00033C3.1665 9.28221 3.67573 10.5116 4.58215 11.418C5.48858 12.3244 6.71796 12.8337 7.99984 12.8337C8.13245 12.8337 8.25962 12.8863 8.35339 12.9801C8.44716 13.0739 8.49984 13.2011 8.49984 13.3337C8.49984 13.4663 8.44716 13.5934 8.35339 13.6872C8.25962 13.781 8.13245 13.8337 7.99984 13.8337C6.45274 13.8337 4.96901 13.2191 3.87505 12.1251C2.78109 11.0312 2.1665 9.54742 2.1665 8.00033C2.1665 6.45323 2.78109 4.9695 3.87505 3.87554C4.96901 2.78157 6.45274 2.16699 7.99984 2.16699Z"
                        fill="white"
                      />
                      <path
                        d="M10.9798 6.35356C10.8915 6.25877 10.8434 6.13341 10.8457 6.00388C10.848 5.87434 10.9005 5.75075 10.9921 5.65914C11.0837 5.56753 11.2073 5.51506 11.3368 5.51277C11.4664 5.51049 11.5917 5.55857 11.6865 5.64689L13.6865 7.64689C13.7801 7.74064 13.8327 7.86772 13.8327 8.00022C13.8327 8.13272 13.7801 8.25981 13.6865 8.35356L11.6865 10.3536C11.6407 10.4027 11.5855 10.4421 11.5242 10.4694C11.4629 10.4967 11.3967 10.5114 11.3295 10.5126C11.2624 10.5138 11.1957 10.5015 11.1334 10.4763C11.0712 10.4512 11.0146 10.4137 10.9671 10.3662C10.9197 10.3188 10.8822 10.2622 10.8571 10.2C10.8319 10.1377 10.8196 10.071 10.8208 10.0039C10.822 9.93674 10.8367 9.87053 10.864 9.8092C10.8913 9.74786 10.9307 9.69266 10.9798 9.64689L12.1265 8.50022H6.6665C6.5339 8.50022 6.40672 8.44754 6.31295 8.35378C6.21918 8.26001 6.1665 8.13283 6.1665 8.00022C6.1665 7.86761 6.21918 7.74044 6.31295 7.64667C6.40672 7.5529 6.5339 7.50022 6.6665 7.50022H12.1265L10.9798 6.35356Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                  {translation?.Logout}
                </Link>
                <Box className="languageBox">
                  <span
                    className={`checkMark ${
                      selectedFlag === "en" ? "activeLanguage" : ""
                    }`}
                    onClick={() => changeLanguage("en")}
                  >
                    <img src={eng1} alt="eng flag"></img> {translation?.English}
                  </span>

                  <span
                    className={`checkMark ${
                      selectedFlag === "ar" ? "activeLanguage" : ""
                    }`}
                    onClick={() => changeLanguage("ar")}
                  >
                    <img src={arb1} alt="eng flag"></img> {translation?.Arabic}
                  </span>
                </Box>
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
});
export default Header;
